export default {
	VNPT: [
		{
			display: 'https://binhduong.vnpt.vn/customer/login',
			value: 'https://binhduong.vnpt.vn/customer/login'
		},
		{
			display: 'https://cto-tt78.vnpt-invoice.com.vn',
			value: 'https://cto-tt78.vnpt-invoice.com.vn'
		},
		{
			display: 'https://cuoc.vnptlongan.vn/Logon.aspx',
			value: 'https://cuoc.vnptlongan.vn/Logon.aspx'
		},
		{
			display: 'https://cuoc.vnpttiengiang.vn',
			value: 'https://cuoc.vnpttiengiang.vn'
		},
		{
			display: 'https://vienthongtayninh.vn/vi/',
			value: 'https://vienthongtayninh.vn/vi/'
		},
		{
			display: 'http://hoadon.dongthap.vnpt.vn',
			value: 'http://hoadon.dongthap.vnpt.vn'
		},
		{
			display: 'https://banhangvnpt.vn/taihoadon',
			value: 'https://banhangvnpt.vn/taihoadon'
		},
		{
			display: 'http://tuyenquang.vnpt.vn/customer/view',
			value: 'http://tuyenquang.vnpt.vn/customer/view'
		},
		{
			display: 'http://hoadon.binhdinh.vnpt.vn',
			value: 'http://hoadon.binhdinh.vnpt.vn'
		},
		{
			display: 'https://ebill.vnpt.vn/hddt.jsp',
			value: 'https://ebill.vnpt.vn/hddt.jsp'
		},
		{
			display: 'https://nbh-tt78.vnpt-invoice.com.vn',
			value: 'https://nbh-tt78.vnpt-invoice.com.vn'
		},
		{
			display: 'https://tn-tt78.vnpt-invoice.com.vn',
			value: 'https://tn-tt78.vnpt-invoice.com.vn'
		},
		{
			display: 'http://nghean.vnpt.vn/customer/login',
			value: 'http://nghean.vnpt.vn/customer/login'
		},
		{
			display: 'https://nuocbdg-tt78.vnpt-invoice.com.vn',
			value: 'https://nuocbdg-tt78.vnpt-invoice.com.vn'
		},
		{
			display: 'http://haugiang.vnpt.vn/customer/login',
			value: 'http://haugiang.vnpt.vn/customer/login'
		},
		{
			display: 'https://billing.vnptphuyen.vn',
			value: 'https://billing.vnptphuyen.vn'
		},
		{
			display: 'https://ntn-tt78.vnpt-invoice.com.vn',
			value: 'https://ntn-tt78.vnpt-invoice.com.vn'
		},
		{
			display: 'https://binhthuan.vnpt.vn/customer/login',
			value: 'https://binhthuan.vnpt.vn/customer/login'
		},
		{
			display: 'http://haiduong.vnpt.vn/customer/login',
			value: 'http://haiduong.vnpt.vn/customer/login'
		},
		{
			display: 'https://angiang.vnpt.vn/customer/login',
			value: 'https://angiang.vnpt.vn/customer/login'
		},
		{
			display: 'http://diennuochd.com.vn',
			value: 'http://diennuochd.com.vn'
		},
		{
			display: 'https://vnptdongnai.vn/customer/login',
			value: 'https://vnptdongnai.vn/customer/login'
		},
		{
			display: 'https://e-invoice-tt78.vingroup.net/AccountVin/LogOn/',
			value: 'https://e-invoice-tt78.vingroup.net/AccountVin/LogOn/'
		}
	],
	EVN: [
		//Hiện tại không hỗ trợ vì chứa googlde captcha 10/2023
		// {
		// 	display: 'https://cskh.cpc.vn',
		// 	value: 'https://cskh.cpc.vn'
		// },
		{
			display: 'https://cskh.evnhcmc.vn',
			value: 'https://cskh.evnhcmc.vn'
		},
		{
			display: 'https://evnhanoi.vn',
			value: 'https://evnhanoi.vn'
		},
		{
			display: 'https://cskh.evnspc.vn',
			value: 'https://cskh.evnspc.vn'
		},
		{
			display: 'https://cskh.npc.com.vn',
			value: 'https://cskh.npc.com.vn'
		}
	]
};
